<template>
    <div class="open-field grid">
        <app-question :data-heading="dataInteraction.descricao"
                      :data-color="dataInteraction.estilo.question.color"></app-question>

        <div class="grid-center">
            <open-field-input :openFieldStyle="openFieldStyle"
                              :disabled="false"/>
        </div>
        
        <div class="grid-bottom text-center" :class="{'flex': isDesktop}">           
            <template v-for="(option, index) in dataInteraction.opcoes" >        
                <button class="btn btn-stretch btn-extra-round text-bold"
                        :key="index"
                        :id="index"  
                        :style="buttonStyle(option.estilo)"
                        @click="$emit('next', option.id)">
                        {{option.nome}}
                </button>
            </template>
        </div>        
         
    </div>
</template>
  
<script>
import buttonStyle from '../../../../interactions/components/interaction/mixins/button-style';
import AppQuestion from './Question'
import OpenFieldInput from '../../../../interactions/components/interaction/components/open-field/input/OpenFieldInput';

export default {
    components: {
        AppQuestion,
        OpenFieldInput
    }, 

    props: {
        dataInteraction: {
            type: Object,
            required: true,
        },
        isDesktop: {
            type: Boolean,            
        }
    },

    computed: {        
        itemStyle() {
            return this.dataInteraction.estilo ? this.dataInteraction.estilo : null
        },

        backgroundType() {
            return this.itemStyle ? this.itemStyle.backgroundType : null
        },

        openFieldStyle() {
            return this.dataInteraction.estilo.openField
        }        
    },   

    mixins: [buttonStyle],
};
</script>
  
<style lang="scss" scoped>
@import "~@variables";

.open-field {
    &.grid {
        .grid-center{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            padding: 20px 34px 42px;
           
        }
        .grid-bottom {           
            gap: 2.5%;
            margin: 0 2.5%;
            
            &.flex {
                display: flex;
                justify-content: center;
                align-items: center;
            }
            
        }
       
    }
}
</style>
  
